let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cinaN")).then(() => parcelRequire('h35rw'));